import { Box, Grid, Typography } from "@mui/material";

import React, { useEffect, useState } from "react";
import SpeedoMeter from "../common/graph/speedo-meter";
import SunburstChart from "../common/graph/sunbrustChart";

type EngineProps = {
  indicatorData: any;
  moduleId: any;
  status: any;
};

const getTwistAngleSetting = () =>
  typeof window !== "undefined" &&
  window.sessionStorage.getItem("twist_angle_page") === "true";

const Engine: React.FC<EngineProps> = ({ indicatorData, moduleId, status }) => {
  const [renderData, setRenderData] = useState<any>();
  const [twistAngleEnabled, setTwistAngleEnabled] = useState(
    getTwistAngleSetting()
  );

  const globalIndicator = renderData?.globalIndicator || [];
  const cylinder_specific_indicators =
    renderData?.cylinder_specific_indicators || [];
  const pressureReadings = renderData?.pressureReadings || [];
  const visibleGlobalIndicator = globalIndicator.filter(
    (item: any) => twistAngleEnabled || item?.indicatorName !== "Twist Angle"
  );

  useEffect(() => {
    // console.log("Indicator Data:", indicatorData);
    setRenderData(indicatorData);
  }, [indicatorData]);

  // Monitor sessionStorage for twist angle changes
  useEffect(() => {
    const interval = setInterval(() => {
      const currentSetting = getTwistAngleSetting();
      setTwistAngleEnabled(currentSetting);
    }, 500); // Check every 500ms

    return () => clearInterval(interval);
  }, []);

  type PressureReading = {
    order: number;
    value: string; // Adjust the type according to your actual data type
  };

  return (
    <Box>
      <Typography
        fontWeight={500}
        fontSize={"24px"}
        sx={{ textAlign: "center" }}
      >
        Global Indicators
      </Typography>
      <Grid item xs={12} my={"20px"}>
        <Grid
          container
          alignItems={"center"}
          justifyContent="center"
          spacing={8}
        >
          {visibleGlobalIndicator
            ?.filter(
              (item: any) =>
                item.indicatorName !== "RPM" &&
                item.indicatorName !== "Bearings"
            )
            .map((val: any) => (
              <Grid
                key={`globalIndicator-${val.indicatorName}`}
                item
                sx={{ display: "flex", flexDirection: "column" }}
                lg={4}
                md={4}
                sm={4}
              >
                <Typography
                  variant="body1"
                  component={"span"}
                  textAlign={"center"}
                  sx={{
                    mb: 1,
                    fontWeight: "400",
                    cursor: "pointer",
                    fontSize: "20px",
                  }}
                  title={val?.tooltip}
                >
                  {val?.indicatorName}
                </Typography>
                <Box
                  sx={{
                    height: "65%",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "20px",
                  }}
                >
                  <SpeedoMeter
                    maxValue={val.indicatorMax}
                    isGradientOpposite={val?.isGradientOpposite}
                    minValue={val?.indicatorMin}
                    value={val?.indicatorValue}
                    isPercent={val?.isPercentage}
                    isGradientColor={val?.isGradientColor}
                    indicatorType={val?.indicatorType}
                    indicatorUnit={val?.indicatorUnit}
                    indicatorName={val?.indicatorName}
                    height={150}
                  />
                </Box>
              </Grid>
            ))}
        </Grid>
      </Grid>
      <Typography
        fontWeight={500}
        fontSize={"24px"}
        sx={{ textAlign: "center" }}
      >
        CYLINDER SPECIFIC INDICATORS
      </Typography>
      <Box
        sx={{
          my: "10px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box sx={{ width: "auto", border: "1px dotted black", my: 5, py: 5 }}>
          <Grid
            container
            alignItems={"center"}
            justifyContent="center"
            spacing={4}
          >
            {cylinder_specific_indicators.map((val: any, index: any) => (
              <Grid
                item
                sx={{ display: "flex", flexDirection: "column" }}
                lg={6}
                md={6}
                sm={6}
              >
                <SunburstChart
                  data={val}
                  elementId={`sunbrust${index}${+new Date()}`}
                  fullScreen={false}
                  borderFlag={true}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      {/* fff */}
      {pressureReadings.length > 0 && pressureReadings.some((reading: PressureReading) => parseFloat(reading.value) > 0) && status === 3 && (
      <div> 
       <Typography fontWeight={500} fontSize={"24px"} sx={{ textAlign: "center" }}>
            PEAK PRESSURE READINGS
        </Typography>
        <Box sx={{ my: "10px", width: "100%", display: "flex", justifyContent: "center" }}>
          <Box sx={{ width: "100%", overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", borderSpacing: 0}}>
           <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "6px", textAlign: "center", /*backgroundColor: "#add8e6",*/ color: "blue", fontWeight: "bold", fontSize: "16px" }}>Cylinder (Firing Order)</th>
                {pressureReadings.map((reading: PressureReading) => (
              <th key={reading.order} style={{ border: "1px solid black", padding: "6px", textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>
              {reading.order}
             </th>
              ))}
            </tr>
           </thead>
          <tbody>
            <tr>
                <td style={{ border: "1px solid black", padding: "6px", textAlign: "center", /*backgroundColor: "#add8e6",*/ color: "blue", fontWeight: "bold", fontSize: "16px" }}>Peak Pressure (in Bar)</td>
                 {pressureReadings.map((reading: PressureReading) => (
                <td key={reading.order} style={{ border: "1px solid black",padding: "6px", textAlign: "center", fontWeight: "bold", fontSize: "16px" }}>
                 {reading.value || "N/A"}{" "}{/* Display 'N/A' if value is missing */}
              </td>
                ))}
              </tr>
            </tbody>
          </table>
          </Box>
        </Box>
      </div>
      )};
    </Box>
  );
};

export default Engine;
